<div class="applicants-container" [class.paddingLeft]="isSidebarExpanded">
    <!-- First Row: Header with Actions -->
    <div class="dashboard-header">
        <div class="header-left">
            <h1 class="fs-18 fw-500" style="margin-bottom: 3px;color: #0075C9;">Applicants</h1>
            <p class="fs-13 gray-text" style="margin: 0;">View and manage all your applicants here.</p>
        </div>
        <div class="header-right">
            <div class="d-flex align-items-center justify-content-end gap-3 flex-nowrap w-100">
                <div class="clearFilters" (click)="clearFilters()" *ngIf="patientIdSelected || cardSelected">
                    Clear filters
                </div>
                <span class="cursor-pointer actionIcon" (click)="onRefresh()" matTooltip="refresh"
                    matTooltipPosition="above">
                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24"
                        [ngClass]="{ 'rotate-animation': isRotating }">
                        <g fill="none" stroke="#0075C9" stroke-linecap="round" stroke-width="1.2">
                            <path
                                d="M6.446 10.512a5.75 5.75 0 0 0 8.429 6.468m2.679-3.492A5.75 5.75 0 0 0 9.125 7.02" />
                            <path stroke-linejoin="round" d="m3.75 12.5l2.5-2.5l2.5 2.5m6.5-1l2.5 2.5l2.5-2.5" />
                        </g>
                    </svg>
                </span>
                <div class="controls" matTooltip="View mode" matTooltipPosition="above">
                    <app-view-mode-toggle [currentViewMode]="viewMode" (viewModeChange)="changeViewMode($event)">
                    </app-view-mode-toggle>
                </div>

                <div class="search-container" [class.expanded]="searchExpanded">
                    <!-- Search Icon (always visible) -->
                    <span class="search-icon actionIcon" (click)="toggleSearch()" aria-label="Open search"
                        *ngIf="!searchExpanded" matTooltip="search" matTooltipPosition="above">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                            <path fill="none" stroke="#0075C9" stroke-linecap="round" stroke-linejoin="round"
                                d="m21 21l-4.343-4.343m0 0A8 8 0 1 0 5.343 5.343a8 8 0 0 0 11.314 11.314"
                                stroke-width="2" />
                        </svg>
                    </span>

                    <!-- mat-form-field input + close icon, shown on expand -->
                    <mat-form-field appearance="outline" class="search-field" *ngIf="searchExpanded">
                        <span matPrefix style="display: flex; align-items: center; margin-left: 8px;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
                                fill="none" stroke="#0075C9" stroke-width="1.2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="m21 21l-4.343-4.343m0 0A8 8 0 1 0 5.343 5.343a8 8 0 0 0 11.314 11.314" />
                            </svg>
                        </span>
                        <input matInput placeholder="Search " [(ngModel)]="searchQuery" (input)="onSearch()" />
                        <span (click)="toggleSearch()" class="cursor-pointer close-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
                                <path fill="none" stroke="#0075C9" stroke-linecap="round" stroke-width="1.5"
                                    d="m8.464 15.535l7.072-7.07m-7.072 0l7.072 7.07" />
                            </svg>
                        </span>
                    </mat-form-field>
                </div>

                <button class="primaryBtn" (click)="onAddApplicant()">Add Applicant</button>
            </div>
        </div>
    </div>

    @if (isDataLoading) {
    <div class="custom-card">
        <div class="loader-pro">
            <app-loader></app-loader>
        </div>
    </div>
    }
    @else if (applicantsData.length > 0 ) {
    <!-- Second Row: Table -->
    @if(viewMode==='list'){

    <app-table-list-view [data]="applicantsData" [displayedColumns]="displayedColumns"
        [columnDisplayNames]="columnDisplayNames" [enumEntityType]="enumEntityType" [tableFrom]="'DIST'">
    </app-table-list-view>
    }

    @else if (viewMode==='grid') {

    <app-table-card-view [data]="applicantsData" [enumRole]='enumRole' (openPatientProfile)="openpatientprofile($event)"
        (openEditForm)="openEditForm($event)" (openRequestME)="openRequestMe($event)"></app-table-card-view>
    }
    }



     

</div>